// import React from "react";
// import "./user-info.scss";
// import { toast } from "react-toastify";
// import { getAllUsers } from "../../../../requests/usersAPI";

// const UserInfo = () => {
//   const notify = () => toast.success("Wow so easy !");
//    const fetchUsers = async () => {
//     try {
//       const response = await getAllUsers();
//       console.log(response.data.data);
//     } catch (error) {}
//   };

//   useEffect(() => {
//     fetchUsers();
//   });
//   return (
//     <section className="user-page-section">
//       <div className="search-input">
//         <h5 className="form-title">User information</h5>
//         <form action="">
//           <div className="input-wrap">
//             <img
//               src="/images/icons/search-icon-input.svg"
//               alt="search-icon-input"
//             />
//             <input
//               type="text"
//               placeholder="Search a user id, full name, phone and email address"
//             />
//           </div>
//         </form>
//       </div>
//       <div className="table-responsive">
//         <table className="table table-striped user-info">
//           <thead className="table-dark">
//             <tr>
//               <th>User ID</th>
//               <th>Full Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Country</th>
//               <th>Address</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {[
//               {
//                 user_id: "USR-1001",
//                 name: "Alice Tan",
//                 email: "alice.tan@example.com",
//                 phone: "+65 9123 4567",
//                 country: "Singapore",
//                 address: "123 Orchard Road, #12-34",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 user_id: "USR-1001",
//                 name: "Alice Tan",
//                 email: "alice.tan@example.com",
//                 phone: "+65 9123 4567",
//                 country: "Singapore",
//                 address: "123 Orchard Road, #12-34",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 user_id: "USR-1001",
//                 name: "Alice Tan",
//                 email: "alice.tan@example.com",
//                 phone: "+65 9123 4567",
//                 country: "Singapore",
//                 address: "123 Orchard Road, #12-34",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 user_id: "USR-1001",
//                 name: "Alice Tan",
//                 email: "alice.tan@example.com",
//                 phone: "+65 9123 4567",
//                 country: "Singapore",
//                 address: "123 Orchard Road, #12-34",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 user_id: "USR-1001",
//                 name: "Alice Tan",
//                 email: "alice.tan@example.com",
//                 phone: "+65 9123 4567",
//                 country: "Singapore",
//                 address: "123 Orchard Road, #12-34",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 user_id: "USR-1001",
//                 name: "Alice Tan",
//                 email: "alice.tan@example.com",
//                 phone: "+65 9123 4567",
//                 country: "Singapore",
//                 address: "123 Orchard Road, #12-34",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//               {
//                 user_id: "USR-1001",
//                 name: "Alice Tan",
//                 email: "alice.tan@example.com",
//                 phone: "+65 9123 4567",
//                 country: "Singapore",
//                 address: "123 Orchard Road, #12-34",
//                 action: "More Details",
//                 img: (
//                   <img
//                     src="/images/icons/detail-arrow.svg"
//                     alt="detail-arrow"
//                   />
//                 ),
//               },
//             ].map((row, i) => (
//               <tr key={i}>
//                 <td>{row.user_id}</td>
//                 <td>{row.name}</td>
//                 <td>{row.email}</td>
//                 <td>{row.phone}</td>
//                 <td>{row.country}</td>
//                 <td>{row.address}</td>
//                 <td>
//                   <span data-bs-toggle="modal" data-bs-target="#userInfoModal">
//                     {row.action}
//                     {row.img}
//                   </span>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div
//         className="modal fade"
//         id="userInfoModal"
//         tabIndex="-1"
//         aria-labelledby="userInfoModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered modal-lg">
//           <div className="modal-content userinfo-modal">
//             <div className="modal-body">
//               <div className="modal-header">
//                 <h5 className="modal-title">User Details</h5>
//                 <img
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                   src="/images/icons/close-circle.svg"
//                   alt="close-circle"
//                 />
//               </div>
//               <div className="user-detail-wrapper">
//                 {/* Bootstrap Nav Tabs */}
//                 <ul
//                   className="nav nav-tabs user-detail"
//                   id="myTab"
//                   role="tablist"
//                 >
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link active"
//                       id="orders-tab"
//                       data-bs-toggle="tab"
//                       data-bs-target="#orders"
//                       type="button"
//                       role="tab"
//                       aria-controls="orders"
//                       aria-selected="false"
//                     >
//                       Orders
//                     </button>
//                   </li>
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link"
//                       id="device-info-tab"
//                       data-bs-toggle="tab"
//                       data-bs-target="#device-info"
//                       type="button"
//                       role="tab"
//                       aria-controls="device-info"
//                       aria-selected="true"
//                     >
//                       Device Information
//                     </button>
//                   </li>
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link"
//                       id="action-tab"
//                       data-bs-toggle="tab"
//                       data-bs-target="#action"
//                       type="button"
//                       role="tab"
//                       aria-controls="action"
//                       aria-selected="true"
//                     >
//                       Actions
//                     </button>
//                   </li>
//                 </ul>

//                 {/* Tab Content */}
//                 <div className="tab-content" id="myTabContent">
//                   <div
//                     className="tab-pane fade show active"
//                     id="orders"
//                     role="tabpanel"
//                     aria-labelledby="orders-tab"
//                   >
//                     <div className="table-responsive">
//                       <table className="table table-striped user-info">
//                         <thead className="table-dark">
//                           <tr>
//                             <th>Order ID</th>
//                             <th>Order Date</th>
//                             <th>Order Type</th>
//                             <th>Status</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {[
//                             {
//                               order_id: "00000001",
//                               date: "12-12-2025",
//                               type: "flights",
//                               status: "Completed",
//                               action: "More Details",
//                               img: (
//                                 <img
//                                   src="/images/icons/detail-arrow.svg"
//                                   alt="detail-arrow"
//                                 />
//                               ),
//                             },
//                             {
//                               order_id: "00000001",
//                               date: "12-12-2025",
//                               type: "hotel",
//                               status: "Pending",
//                               action: "More Details",
//                               img: (
//                                 <img
//                                   src="/images/icons/detail-arrow.svg"
//                                   alt="detail-arrow"
//                                 />
//                               ),
//                             },
//                             {
//                               order_id: "00000001",
//                               date: "12-12-2025",
//                               type: "flights",
//                               status: "Completed",
//                               action: "More Details",
//                               img: (
//                                 <img
//                                   src="/images/icons/detail-arrow.svg"
//                                   alt="detail-arrow"
//                                 />
//                               ),
//                             },
//                           ].map((row, i) => (
//                             <tr key={i}>
//                               <td>{row.order_id}</td>
//                               <td>{row.date}</td>
//                               <td>{row.type}</td>
//                               <td>{row.status}</td>
//                               <td>
//                                 <span onClick={notify}>
//                                   {row.action} {row.img}
//                                 </span>
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                   <div
//                     className="tab-pane fade"
//                     id="device-info"
//                     role="tabpanel"
//                     aria-labelledby="device-info-tab"
//                   >
//                     <div className="table-responsive">
//                       <table className="table table-striped user-info">
//                         <thead className="table-dark">
//                           <tr>
//                             <th>IP Address</th>
//                             <th>Host+ISP</th>
//                             <th>IP</th>
//                             <th>Date & Time</th>
//                             <th>Device</th>
//                             <th>Action</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {[
//                             {
//                               ip_address: "103.45.78.22 (Singapore)",
//                               host_isp: "Starhub.net.sg, Starthub",
//                               ip: "103.45.78.22",
//                               date_time: "12-12-2025 at 12:00 pm",
//                               device: "MacBook Pro",
//                               action1: "Log On",
//                               action2: "More Details",
//                               img: (
//                                 <img
//                                   src="/images/icons/detail-arrow.svg"
//                                   alt="detail-arrow"
//                                 />
//                               ),
//                             },
//                             {
//                               ip_address: "103.45.78.22 (Singapore)",
//                               host_isp: "Starhub.net.sg, Starthub",
//                               ip: "103.45.78.22",
//                               date_time: "12-12-2025 at 12:00 pm",
//                               device: "MacBook Pro",
//                               action1: "Log On",
//                               action2: "More Details",
//                               img: (
//                                 <img
//                                   src="/images/icons/detail-arrow.svg"
//                                   alt="detail-arrow"
//                                 />
//                               ),
//                             },
//                             {
//                               ip_address: "103.45.78.22 (Singapore)",
//                               host_isp: "Starhub.net.sg, Starthub",
//                               ip: "103.45.78.22",
//                               date_time: "12-12-2025 at 12:00 pm",
//                               device: "MacBook Pro",
//                               action1: "Log On",
//                               action2: "More Details",
//                               img: (
//                                 <img
//                                   src="/images/icons/detail-arrow.svg"
//                                   alt="detail-arrow"
//                                 />
//                               ),
//                             },
//                           ].map((row, i) => (
//                             <tr key={i}>
//                               <td>{row.ip_address}</td>
//                               <td>{row.host_isp}</td>
//                               <td>{row.ip}</td>
//                               <td>{row.date_time}</td>
//                               <td>{row.device}</td>
//                               <td>{row.action1}</td>
//                               <td>
//                                 <span>
//                                   {row.action2} {row.img}
//                                 </span>
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                   <div
//                     className="tab-pane fade"
//                     id="action"
//                     role="tabpanel"
//                     aria-labelledby="action-tab"
//                   >
//                     <form action="">
//                       <div className="floating-label">
//                         <input
//                           type="text"
//                           name="givenNames"
//                           placeholder="ali675tahir@gmail.com"
//                           className="floating-label-input"
//                           id="givenNames"
//                           autoComplete="given-name"
//                         />
//                         <label className="floating-label-text">
//                           Email <span>*</span>
//                         </label>
//                       </div>
//                     </form>
//                     <div className="modal-footer">
//                       <button type="button" className="btn">
//                         Update Email
//                       </button>
//                       <button type="button" className="btn">
//                         Reset Password
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default UserInfo;
import React, { useEffect, useState } from "react";
import "./user-info.scss";
import { toast } from "react-toastify";
import { getAllUsers } from "../../../../requests/usersAPI";
import { LocalStorageKeys } from "../../../../constants/LocalStorageKeys";
import { getOrdersByUserId } from "../../../../requests/usersAPI";

const UserInfo = () => {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState([]);
  const [orders, setOrders] = useState([]);

  const fetchUsers = async () => {
    try {
      const response = await getAllUsers();
      if (response?.data?.data) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);
  const fetchOrderByUserId = async (userId) => {
    try {
      const response = await getOrdersByUserId(userId);
      setOrders(response.data);
      console.log(response.data);
    } catch (error) {}
  };

  return (
    <section className="user-page-section">
      <div className="search-input">
        <h5 className="form-title">User information</h5>
        <form action="">
          <div className="input-wrap">
            <img
              src="/images/icons/search-icon-input.svg"
              alt="search-icon-input"
            />
            <input
              type="text"
              placeholder="Search a user id, full name, phone and email address"
            />
          </div>
        </form>
      </div>
      <div className="table-responsive">
        <table className="table table-striped user-info">
          <thead className="table-dark">
            <tr>
              <th>User ID</th>
              <th>Full Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Country</th>
              <th>Address</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {users?.length > 0 ? (
              users?.map((user, i) => (
                <tr key={i}>
                  {/* <td>{user._id}</td> */}
                  <td>
                    {user && user._id
                      ? `USR-${String(user._id).slice(-4)}`
                      : "USR-0000"}
                  </td>
                  <td>{user.fullName || "-"}</td>
                  <td>{user.email || "-"}</td>
                  <td>{user.phone || "-"}</td>
                  <td>{user.country || "-"}</td>
                  <td>{user.address || "-"}</td>
                  <td>
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#userInfoModal"
                      onClick={() => {
                        fetchOrderByUserId(user._id);
                      }}
                    >
                      More Details{" "}
                      <img
                        src="/images/icons/detail-arrow.svg"
                        alt="detail-arrow"
                      />
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No users found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal Section */}
      <div
        className="modal fade"
        id="userInfoModal"
        tabIndex="-1"
        aria-labelledby="userInfoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content userinfo-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">User Details</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>
              <div className="user-detail-wrapper">
                {/* Bootstrap Nav Tabs */}
                <ul
                  className="nav nav-tabs user-detail"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="orders-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#orders"
                      type="button"
                      role="tab"
                      aria-controls="orders"
                      aria-selected="false"
                    >
                      Orders
                    </button>
                  </li>
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="device-info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#device-info"
                      type="button"
                      role="tab"
                      aria-controls="device-info"
                      aria-selected="true"
                    >
                      Device Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="action-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#action"
                      type="button"
                      role="tab"
                      aria-controls="action"
                      aria-selected="true"
                    >
                      Actions
                    </button>
                  </li> */}
                </ul>

                {/* Tab Content */}
                <div className="tab-content" id="myTabContent">
                  {/* <div
                    className="tab-pane fade show active"
                    id="orders"
                    role="tabpanel"
                    aria-labelledby="orders-tab"
                  >
                    <div className="table-responsive">
                      <table className="table table-striped user-info">
                        <thead className="table-dark">
                          <tr>
                            <th>Order ID</th>
                            <th>Order Date</th>
                            <th>Order Type</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            {
                              order_id: "00000001",
                              date: "12-12-2025",
                              type: "flights",
                              status: "Completed",
                              action: "More Details",
                              img: (
                                <img
                                  src="/images/icons/detail-arrow.svg"
                                  alt="detail-arrow"
                                />
                              ),
                            },
                            {
                              order_id: "00000002",
                              date: "13-12-2025",
                              type: "hotel",
                              status: "Pending",
                              action: "More Details",
                              img: (
                                <img
                                  src="/images/icons/detail-arrow.svg"
                                  alt="detail-arrow"
                                />
                              ),
                            },
                          ].map((row, i) => (
                            <tr key={i}>
                              <td>{row.order_id}</td>
                              <td>{row.date}</td>
                              <td>{row.type}</td>
                              <td>{row.status}</td>
                              <td>
                                <span>
                                  {row.action} {row.img}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div> */}
                  <div
                    className="tab-pane fade show active"
                    id="orders"
                    role="tabpanel"
                    aria-labelledby="orders-tab"
                  >
                    <div className="table-responsive">
                      <table className="table table-striped user-info">
                        <thead className="table-dark">
                          <tr>
                            <th>Order ID</th>
                            <th>Order Date</th>
                            <th>Package</th>
                            <th>Status</th>
                            {/* <th>Action</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {orders?.length > 0 ? (
                            orders?.map((order, i) => (
                              <tr key={i}>
                                <td>{order.orderId || "-"}</td>
                                <td>
                                  {order.created_at
                                    ? new Date(
                                        order.created_at
                                      ).toLocaleDateString()
                                    : "-"}
                                </td>
                                <td>
                                  {order.name || order.packageCode || "-"}
                                </td>
                                <td>
                                  {order.smdpStatus || order.tooltip || "-"}
                                </td>
                                {/* <td>
                                  <span>
                                    More Details{" "}
                                    <img
                                      src="/images/icons/detail-arrow.svg"
                                      alt="detail-arrow"
                                    />
                                  </span>
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No orders found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="device-info"
                    role="tabpanel"
                    aria-labelledby="device-info-tab"
                  >
                    <div className="table-responsive">
                      <table className="table table-striped user-info">
                        <thead className="table-dark">
                          <tr>
                            <th>IP Address</th>
                            <th>Host+ISP</th>
                            <th>IP</th>
                            <th>Date & Time</th>
                            <th>Device</th>
                            <th>Action</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            {
                              ip_address: "103.45.78.22 (Singapore)",
                              host_isp: "Starhub.net.sg, Starthub",
                              ip: "103.45.78.22",
                              date_time: "12-12-2025 at 12:00 pm",
                              device: "MacBook Pro",
                              action1: "Log On",
                              action2: "More Details",
                              img: (
                                <img
                                  src="/images/icons/detail-arrow.svg"
                                  alt="detail-arrow"
                                />
                              ),
                            },
                          ].map((row, i) => (
                            <tr key={i}>
                              <td>{row.ip_address}</td>
                              <td>{row.host_isp}</td>
                              <td>{row.ip}</td>
                              <td>{row.date_time}</td>
                              <td>{row.device}</td>
                              <td>{row.action1}</td>
                              <td>
                                <span>
                                  {row.action2} {row.img}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* <div
                    className="tab-pane fade"
                    id="action"
                    role="tabpanel"
                    aria-labelledby="action-tab"
                  >
                    <form action="">
                      <div className="floating-label">
                        <input
                          type="text"
                          name="givenNames"
                          placeholder="ali675tahir@gmail.com"
                          className="floating-label-input"
                          id="givenNames"
                          autoComplete="given-name"
                        />
                        <label className="floating-label-text">
                          Email <span>*</span>
                        </label>
                      </div>
                    </form>
                    <div className="modal-footer">
                      <button type="button" className="btn">
                        Update Email
                      </button>
                      <button type="button" className="btn">
                        Reset Password
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserInfo;
